import CameraHelperMarker from "@/domain/marker/CameraHelperMarker";
import ClientBase from "../ClientBase";

class CameraHelperClient extends ClientBase {

    async getCameraHelpersByScanId(scanId) {
        const data = await this.get(`api/v1/camerahelpers/scans/${scanId}`);
        return data?.map(helper => new CameraHelperMarker(helper)) ?? [];
    }
}

export default new CameraHelperClient();